// controllers/component-size-controller.ts
import "@adornis/base/client/frontend-helpers/index.js";
import "@lit/reactive-element";
import { debounceTime, map, Observable, shareReplay, startWith } from "rxjs";
import "./chemistry-controller.js";
import { getDevice } from "./window-size-controller.js";
var ComponentSizeController = class {
  constructor(host, { debounceTime: time = 25, triggerUpdates = true } = {}) {
    this.host = host;
    this._triggerUpdates = triggerUpdates;
    this.observable = new Observable(
      (subscriber) => new ResizeObserver((entries) => subscriber.next(entries[0].contentRect)).observe(this.host)
    ).pipe(
      debounceTime(25),
      startWith({
        bottom: 0,
        height: 0,
        left: 0,
        right: 0,
        top: 0,
        width: 0,
        x: 0,
        y: 0
      }),
      map((domRect) => ({
        bottom: domRect.bottom,
        height: domRect.height,
        left: domRect.left,
        right: domRect.right,
        top: domRect.top,
        width: domRect.width,
        x: domRect.x,
        y: domRect.y,
        componentDevice: getDevice(domRect.width, this.host.sizes.breakPoints)
      })),
      shareReplay(1)
    );
    this.host.addController(this);
  }
  hostConnected() {
    this._subscription?.unsubscribe();
    this._subscription = this.observable.subscribe((size) => {
      this.value = size;
      this.width = size.width;
      this.height = size.height;
      this.componentDevice = size.componentDevice;
      if (this._triggerUpdates)
        this.host.requestUpdate();
    });
  }
  hostDisconnected() {
    this._subscription?.unsubscribe();
  }
};
export {
  ComponentSizeController
};
